import { gotoLogin, storage, getAuthToken } from './utils';
import Basil from 'basil.js';

class AuthService {
  // Interfaces with the API OAuth provider and utilizes localStorage
  // to persist the username/token on the client.
  // https://assets.boxcast.com/api/reference/#authentication

  constructor($http, $rootScope, Facebook) {
    'ngInject';
    this.$http = $http;
    this.user = $rootScope.user;
    this.Facebook = Facebook;
  }

  testAccessToken() {
    // The access token is limited in time, so we need to be able to check if
    // when it's no longer good. Hit the /account API endpoint to see if it's
    // expired.
    return this.$http
      .get(API_ROOT + '/account')
      .then(() => true)
      .catch(() => false);
  }

  initHttpAuthorzation() {
    // Stuff the auth header in the $http service so all other requests are automagically authorized
    this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.getAuthToken();
  }

  logout() {
    this.Facebook.logout();
    storage.clear();
    Basil.cookie.set('bxe-logged-out', '1', {
      expireDays: 365,
      sameSite: 'none',
      secure: true,
      domain: 'boxcast.com',
    });
    location.replace(LOGOUT_URL);
    throw new Error('halt');
  }
}

// Register the service with angular
angular.module('app.auth').service('AuthService', AuthService);



// WEBPACK FOOTER //
// ./app/auth/auth-service.js